<template>
    <modal :title="setModel!=undefined?'Update Worker':'Add Worker'" @close="$emit('close')">
        <template #content>
            <Form method="dialog" v-slot="{ errors }" class="floating-labels p-1rem row" ref="form">
                <div class="col-6">
                    <formGroup :title="'Name'" v-model="model.Name" :errors="errors" :rules="{required:true}" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-6">
                    <formGroup :title="'Platform'" v-model="model.Platform" :errors="errors" :rules="{required:true}" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-6">
                    <formGroup :title="'Zone'" v-model="model.Zone" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-6">
                    <formGroup :title="'IP'" v-model="model.IP" :errors="errors" :rules="{required:true}" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-12">
                    <formGroup :title="'Description'" :as="'textarea'" v-model="model.Description" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-auto">
                    <formGroup :title="'GRPC'" :as="'checkbox'" v-model="model.GRPC" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-auto">
                    <formGroup :title="'ProxyManager'" :as="'checkbox'" v-model="model.ProxyManager" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-auto">
                    <formGroup :title="'Active'" :as="'checkbox'" v-model="model.Active" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
            </Form>
        </template>
        <template #foot>
            <Btn class="btn-success btn-md" @click="save" :process="process">{{setModel!=undefined?'Update Worker':'Add Worker'}}</Btn>
        </template>
    </modal>
</template>

<script>
    export default {
        props:{
            setModel:Object
        },
        data(){
            return{
                model:{
                    Id:null,
                    Name:"",
                    Platform:"",
                    Zone:"",
                    IP:"",
                    GRPC:false,
                    ProxyManager:false,    
                    Description:"",
                    Active:false
                },
                errs:{

                },
                process:false
            }
        },
        created(){
            if(this.setModel!=undefined){
                this.model={...this.setModel};
            }
        },
        methods:{
            save(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.process=true;
                        this.$appAxiosAdmin.put(`Workers`,this.model).then(response => {
                            this.process=false;
                            this.$swal({
                                icon:"success",
                                title:"Success",
                                text:this.setModel!=undefined?"Worker has been successfully updated.":"Worker has been successfully added.",
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                            if(this.setModel!=undefined){
                                this.$emit("update",response.data);
                            }else{
                                this.$emit("add",response.data);
                            }
                            this.$emit("close");
                        }).catch(err=>{
                            this.process=false;
                            this.$isError(err);
                        });
                    }
                });
            }
        }
    }
</script>

<style>

</style>